import { namespace } from '../../../../../FrontendBundle/Resources/js/ofcs';
import ReplaceItemsCommand from './replaceItemsCommand';

/**
 * Switch successor command
 *
 * @class SwitchSuccessorCommand
 * @extends AbstractCommand
 */
export default class SwitchSuccessorCommand extends ReplaceItemsCommand {
    /**
     * Return title
     *
     * @return {string}
     */
    getTitle() {
        if (this.replacements.length > 1) {
            return `Switch to successor of ${this.replacements.length} items`;
        }
        return 'Switch to successor of item';
    }
}

namespace('Ofcs.Editor.Command');
window.Ofcs.Editor.Command.SwitchSuccessorCommand = SwitchSuccessorCommand;
